/**
 * Lightweight A/B Testing Utility
 * Phase 8: Data-driven optimization
 */

const STORAGE_PREFIX = 'cs_exp_';

/**
 * Gets or assigns a variant for a specific experiment
 * @param {string} experimentId - Unique ID for the experiment
 * @param {string[]} variants - Array of variant IDs (e.g. ['A', 'B'])
 * @returns {string} Assigned variant ID
 */
export const getExperimentVariant = (experimentId, variants = ['A', 'B']) => {
  const key = `${STORAGE_PREFIX}${experimentId}`;
  let assignedVariant = localStorage.getItem(key);

  if (!assignedVariant || !variants.includes(assignedVariant)) {
    // Random assignment
    const index = Math.floor(Math.random() * variants.length);
    assignedVariant = variants[index];
    localStorage.setItem(key, assignedVariant);
    
    // Track assignment
    trackExperimentEvent(experimentId, assignedVariant, 'assignment', {
      source: 'ABTestingUtil'
    });
  }

  return assignedVariant;
};

/**
 * Tracks an event tied to an experiment
 * @param {string} experimentId 
 * @param {string} variantId 
 * @param {string} eventName 
 * @param {object} data 
 */
export const trackExperimentEvent = (experimentId, variantId, eventName, data = {}) => {
  const eventPayload = {
    experiment_id: experimentId,
    variant_id: variantId,
    ...data,
    location: window.location.pathname,
    timestamp: new Date().toISOString()
  };

  if (import.meta.env.DEV) {
    console.log(`[AB Test] ${experimentId} (${variantId}) - ${eventName}`, eventPayload);
  }

  // Google Tag Manager / Global Tag
  if (typeof window.gtag === 'function') {
    window.gtag('event', `exp_${eventName}`, {
      event_category: 'AB_Testing',
      event_label: `${experimentId}:${variantId}`,
      ...eventPayload
    });
  }

  // Umami Analytics
  if (window.umami && typeof window.umami.track === 'function') {
    window.umami.track(`EXP_${experimentId}_${variantId}_${eventName.toUpperCase()}`, eventPayload);
  }
};
